import type { AppLocale } from "@/config/app-locale";

export type RefundSection = {
  title: string;
  paragraphs?: readonly string[];
};

export const refundCopy = {
  en: {
    title: "Refund Policy",
    version: "Version 1.1 — September 2026",
    precedence: "In the event of any discrepancy or difference in interpretation between the French and English versions of this Refund Policy, the French version shall prevail.",
    sections: [
      {
        title: "1. All Sales Are Final",
        paragraphs: [
          "Due to the immediate access and digital nature of our services, all purchases made on CVBuilder.ca (operated by 12 services-conseils inc.) are non-refundable. This non-refund policy also applies to paid plans purchased after exhausting the two (2) free analysis quota per user. Once a resume template or document is generated, accessed, or downloaded, no refunds, cancellations, or exchanges will be provided.",
        ],
      },
      {
        title: "2. Technical Exceptions",
        paragraphs: [
          "If a system error or technical issue prevents you from accessing or downloading the product you paid for, please contact our support team. We will review your request on a case-by-case basis to resolve the issue or provide a working replacement.",
        ],
      },
      {
        title: "3. Contact Us",
        paragraphs: [
          "If you have any questions or concerns regarding your purchase, please contact us at team@cvbuilder.ca",
        ],
      },
    ] satisfies readonly RefundSection[],
  },
  fr: {
    title: "Politique de remboursement",
    version: "Version 1.1 — Septembre 2026",
    precedence: "En cas de divergence ou de différence d'interprétation entre les versions française et anglaise de la présente Politique de remboursement, la version française prévaudra.",
    sections: [
      {
        title: "1. Toutes les ventes sont finales",
        paragraphs: [
          "En raison de la nature numérique et de l'accès immédiat à nos services, tous les achats effectués sur CVBuilder.ca (exploité par 12 services-conseils inc.) sont fermes et non remboursables. Cette politique de non-remboursement s'applique également aux forfaits payants souscrits à la suite de l'épuisement du quota de deux (2) analyses gratuites par utilisateur. Dès qu'un modèle de CV ou un document est généré, consulté ou téléchargé, aucun remboursement, annulation ou échange ne sera accordé.",
        ],
      },
      {
        title: "2. Exceptions techniques",
        paragraphs: [
          "Si une erreur système ou un problème technique vous empêche d'accéder à votre document ou de le télécharger après le paiement, veuillez contacter notre équipe d'assistance. Nous analyserons votre demande au cas par cas afin de résoudre le problème technique ou de vous fournir une version fonctionnelle de votre document.",
        ],
      },
      {
        title: "3. Nous contacter",
        paragraphs: [
          "Pour toute question concernant votre achat ou pour signaler un problème technique, écrivez-nous à : team@cvbuilder.ca",
        ],
      },
    ] satisfies readonly RefundSection[],
  },
} as const satisfies Record<AppLocale, object>;
